import styled from 'styled-components';
import { Modal, Button, Group } from '@veneer/core';
import { primitives } from '@veneer/primitives';
const { color, typography, layout } = primitives;
import { customColors } from 'src/styles/customColors';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 768px) {
    gap: 20px;
  }
`;

export const ModalTitle = styled.div`
  font-size: ${typography.size7};
  line-height: ${typography.lineHeight5};
  font-weight: ${typography.weight4};
  color: ${color.gray12};
  text-align: left;

  @media (max-width: 768px) {
    font-size: ${typography.size4};
    line-height: ${typography.lineHeight4};
    font-weight: ${typography.weight4};
  }
`;

export const FirstParagraph = styled.p`
  font-size: ${typography.size2};
  line-height: ${typography.lineHeight3};
  font-weight: ${typography.weight3};
  color: ${color.gray12};
  text-align: left;

  @media (max-width: 768px) {
    font-size: ${typography.size1};
    line-height: ${typography.lineHeight2};
    font-weight: ${typography.weight3};
  }
`;

export const SecondParagraph = styled.p`
  font-size: ${typography.size2};
  line-height: ${typography.lineHeight3};
  font-weight: ${typography.weight3};
  color: ${color.gray12};
  text-align: left;

  @media (max-width: 768px) {
    font-size: ${typography.size1};
    line-height: ${typography.lineHeight2};
    font-weight: ${typography.weight3};
  }
`;

export const ThirdParagraph = styled.p`
  font-size: ${typography.size2};
  line-height: ${typography.lineHeight3};
  font-weight: ${typography.weight3};
  color: ${color.gray12};
  text-align: left;

  @media (max-width: 768px) {
    font-size: ${typography.size1};
    line-height: ${typography.lineHeight2};
    font-weight: ${typography.weight3};
  }
`;

export const Link = styled.a`
  color: ${color.electricBlue7};
  text-decoration: underline;

  &:hover {
    text-decoration: underline;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  @media (max-width: 768px) {
    align-items: flex-start;
  }
`;

export const Checkbox = styled.input`
  width: 24px;
  height: 24px;
  accent-color: ${color.electricBlue7};
  cursor: pointer;
`;

export const CheckboxLabel = styled.label`
  font-size: ${typography.size2};
  line-height: ${typography.lineHeight3};
  font-weight: ${typography.weight3};
  color: ${color.gray12};
  cursor: pointer;
  flex: 1;

  @media (max-width: 768px) {
    font-size: ${typography.size1};
    line-height: ${typography.lineHeight2};
    font-weight: ${typography.weight3};
  }
`;

export const StyledGroup = styled(Group)`
  gap: 13px;
  display: flex;
  justify-content: flex-end;

  @media (max-width: 768px) {
    justify-content: flex-end;
  }
`;

export const CancelButton = styled(Button)`
  min-width: 112px;
  height: 48px;
  padding: 14px 20px;
  border-radius: ${layout.cornerRadius2}px;
  border: 1px solid ${color.electricBlue7};
  font-size: ${typography.size2};
  font-weight: ${typography.weight3};
  line-height: ${typography.lineHeight2};
  width: auto;

  @media (max-width: 768px) {
    min-width: 112px;
    height: 36px;
    padding: 10px 16px;
    font-size: ${typography.size1};
    line-height: ${typography.lineHeight2};
  }
`;

export const ProceedButton = styled(Button)`
  min-width: 112px;
  height: 48px;
  padding: 14px 20px;
  border-radius: ${layout.cornerRadius2}px;
  background-color: ${color.electricBlue7};
  font-size: ${typography.size2};
  font-weight: ${typography.weight3};
  line-height: ${typography.lineHeight2};
  width: auto;

  &:disabled {
    background-color: ${customColors.lightGray};
    color: ${color.gray5};
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    min-width: 112px;
    height: 36px;
    padding: 10px 16px;
    font-size: ${typography.size1};
    line-height: ${typography.lineHeight2};
  }
`;

export const StyledModal = styled(Modal)`
  && {
    max-width: 800px !important;
    max-height: 504px !important;
    width: 100%;
    height: 100%;
    border-radius: ${layout.cornerRadius2}px !important;
    padding: 40px 48px !important;

    @media (max-width: 768px) {
      max-width: calc(100vw - 32px) !important;
      width: calc(100vw - 32px) !important;
      height: auto !important;
      max-height: calc(100vh - 64px) !important;
      padding: 24px !important;
      .veneer-modal__dialog {
        margin: 16px !important;
      }

      .veneer-modal__footer {
        justify-content: center !important;
      }
    }
  }
`;
